export default "__VITE_ASSET__1XLIOEZm__"